import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {AssetCategoryState} from "./AssetCategoryState";
import {
	ASSET_CATEGORIES_FETCHED,
	ASSET_CATEGORY_CREATED,
	ASSET_CATEGORY_SORT_ORDER_UPDATED,
	ASSET_CATEGORY_UPDATED
} from "../../action/assetCategory/actionType";

const initState: AssetCategoryState = {
	assetCategories: none,

};

const reducer = handleActions({
	[ASSET_CATEGORIES_FETCHED]: (state: AssetCategoryState, action: Action<any>): AssetCategoryState => {
		return {...state, assetCategories: option(action.payload.assetCategories)}
	},
	[ASSET_CATEGORY_CREATED]: (state: AssetCategoryState, action: Action<ASSET_CATEGORY_CREATED>): AssetCategoryState => {
		return {
			...state,
			assetCategories: option(state.assetCategories.getOrElse([]).concat(action.payload.assetCategory))
		}
	},
	[ASSET_CATEGORY_UPDATED]: (state: AssetCategoryState, action: Action<ASSET_CATEGORY_UPDATED>): AssetCategoryState => {
		const assetCategories = state.assetCategories.getOrElse([]).map(
			ac => ac.id == action.payload.assetCategory.id ? action.payload.assetCategory : ac);
		return {...state, assetCategories: option(assetCategories)}
	},
	[ASSET_CATEGORY_SORT_ORDER_UPDATED]: (state: AssetCategoryState,
		action: Action<ASSET_CATEGORY_SORT_ORDER_UPDATED>): AssetCategoryState => {
		return {...state, assetCategories: option(action.payload.assetCategories)};
	},
}, initState);

export default reducer;